module.exports = __webpack_public_path__ + "images/content.0d81b9c3950dd7fa8719719b750ae933.svg";